const BACKEND_API = {
  
  INSTRUMENT_SOUND: "http://localhost:4000/api/instrument",
 
};

export default BACKEND_API;
